export enum PermissionKey {
  ALL = "*",
  SPRING_ALL = "spring.*",
  ACCOUNT_ALL = "account.*",
  SPRING_ADMIN_ALL = "spring.admin.*",
  SPRING_OPERATIONS_ALL = "spring.operations.*",
  SPRING_DEBT_SETTLEMENT_ALL = "spring.debt_settlement.*",
  SPRING_CALL_CENTER_ALL = "spring.call_center.*",
  SPRING_LEGAL_COLLECTIONS_ALL = "spring.legal_collections.*",
  SPRING_COMPLIANCE_ALL = "spring.compliance.*",
  SPRING_GR4VY_ALL = "spring.gr4vy.*",
  SPRING_OPERATIONS = "spring.operations",
  SPRING_DEBT_SETTLEMENT = "spring.debt_settlement",
  SPRING_INVENTORY = "spring.inventory",
  SPRING_COMPLIANCE = "spring.compliance",
  SPRING_COMPLIANCE_OVERVIEW = "spring.compliance.overview",
  SPRING_COMPLIANCE_DISPUTES = "spring.compliance.disputes",
  SPRING_COMPLIANCE_DOCUMENT_EXPORT = "spring.compliance.document_export",
  SPRING_BANKRUPTCIES = "spring.bankruptcies",
  SPRING_LEGAL_COLLECTIONS = "spring.legal_collections",
  SPRING_CALL_CENTER = "spring.call_center",
  SPRING_TASKS = "spring.tasks",
  SPRING_REACH = "spring.reach",
  SPRING_ADMIN = "spring.admin",
  SPRING_GR4VY = "spring.gr4vy",
  SPRING_OPERATIONS_ACCOUNT_IMPORTS = "spring.operations.account_imports",
  SPRING_OPERATIONS_ACCOUNT_MANAGEMENT = "spring.operations.account_management",
  SPRING_OPERATIONS_PAYMENTS = "spring.operations.payments",
  SPRING_OPERATIONS_WASHING = "spring.operations.washing",
  SPRING_OPERATIONS_USER_LEVEL_MEDIA = "spring.operations.user_level_media",
  SPRING_OPERATIONS_BATCH_LEVEL_MEDIA = "spring.operations.batch_level_media",
  SPRING_OPERATIONS_PRICING_IMPORT = "spring.operations.pricing_import",
  SPRING_OPERATIONS_PRICING_BATCH = "spring.operations.pricing_batch",
  SPRING_OPERATIONS_IN_HOUSE_HANDLING = "spring.operations.in_house_handling",
  SPRING_DEBT_SETTLEMENT_OVERVIEW = "spring.debt_settlement.overview",
  SPRING_DEBT_SETTLEMENT_BULK_OPERATIONS = "spring.debt_settlement.bulk_operations",
  SPRING_DEBT_SETTLEMENT_ANONYMOUS_COMMS = "spring.debt_settlement.anonymous_comms",
  SPRING_DEBT_SETTLEMENT_COMPANIES = "spring.debt_settlement.companies",
  SPRING_LEGAL_COLLECTIONS_BULK_OPERATIONS = "spring.legal_collections.bulk_operations",
  SPRING_CALL_CENTER_CONVERSATIONS = "spring.call_center.conversations",
  SPRING_CALL_CENTER_BLOCKED_NUMBERS = "spring.call_center.blocked_numbers",
  SPRING_CALL_CENTER_REX_SKILLS = "spring.call_center.rex_skills",
  SPRING_CALL_CENTER_SHIFT_MANAGEMENT = "spring.call_center.shift_management",
  SPRING_ADMIN_ROLES = "spring.admin.roles",
  SPRING_ADMIN_PEOPLE = "spring.admin.people",
  SPRING_ADMIN_SFTP_MANAGEMENT = "spring.admin.sftp_management",
  SPRING_GR4VY_ROUTING_VALIDATION = "spring.gr4vy.routing_validation",
  SPRING_PARTNER_MANAGEMENT = "spring.partners",
  ACCOUNT_VIEW_FULL_SSN = "account.view_full_ssn",
  ACCOUNT_ASSIGN_TO_REX = "account.assign_to_rex",
  ACCOUNT_EDIT_NAME_DOB = "account.edit_name_dob",
  ACCOUNT_DISPUTE_OPERATIONS = "account.dispute_operations",
  ACCOUNT_PAYMENT_REVERSALS = "account.payment_reversals",
  ACCOUNT_UNMASK_COMMUNICATIONS = "account.unmask_communications",
  ACCOUNT_GENERATE_DOCUMENTS = "account.generate_documents",
  ACCOUNT_MANAGE_FLAGS = "account.manage_flags",
  ACCOUNT_DELETE_CREDIT_REPORT = "account.delete_credit_report",
  ACCOUNT_UPDATE_DISPOSITION = "account.update_disposition",
  ACCOUNT_OVERRIDE_DISABLED_COMMS = "account.override_disabled_comms",
}
